import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { FarmResponse } from '@/types/api';

/**
 * The farm's time zone (`farms.timezone`; the Overview response does not carry it). Shares the
 * settings page's farm cache entry. `settled` is false until the farm has loaded or failed, so a
 * stamp is never drawn in the browser's zone first and then jumps.
 */
export function useFarmTimezone(farmId: string | null) {
  const { data, isFetched, isError } = useQuery({
    queryKey: ['farm', farmId],
    queryFn: () => api.get<{ data: FarmResponse }>(`/api/v1/farms/${farmId}`),
    enabled: !!farmId,
    staleTime: 5 * 60 * 1000,
  });
  return { timezone: data?.data?.timezone, settled: !farmId || isFetched || isError };
}
